import { Component, input, model, output } from '@angular/core';

import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
export interface EspecialidadeRelacionadaRow {
    especialidade: string;
    areaAtuacao: string;
}

@Component({
    selector: 'app-especialidades-relacionadas-dialog',
    standalone: true,
    imports: [DialogoPadraoDirective, Dialog, Button, TableModule],
    templateUrl: './especialidades-relacionadas.html',
    styleUrl: './especialidades-relacionadas.scss'
})
export class EspecialidadesRelacionadasDialogComponent {
    // Controle de visibilidade seguindo padrão do sistema (two-way via model())
    showDialog = model.required<boolean>();

    // Lista de itens a serem exibidos
    itens = input<EspecialidadeRelacionadaRow[]>([]);

    // Evento simples de fechamento
    closed = output<void>();

    hide(): void {
        this.showDialog.set(false);
        this.closed.emit();
    }
}
